import React, { ChangeEvent, useEffect } from 'react';

import { EnvironmentTypes } from 'pages/OpenProtocol/Description/interface';
import { Visibility } from 'components/Visibility';
import { Column } from 'components/Layout/Grid';
import Text from 'components/Text';

import { useEnvironment } from 'hooks/useEnvironment';
import { DescriptionSimpleProps } from './interface';
import { EnumCategories } from 'models/Ticket';

import { TextAreaDescription } from './styles';

export const DescriptionSimple: React.FC<DescriptionSimpleProps> = (props) => {
  const { description, setDescription, protocolCategory } = props;
  const development = useEnvironment();

  useEffect(() => {
    const environment = process.env.REACT_APP_HOME_URL;

    if (description === '' && (development || environment === EnvironmentTypes.dev || environment === EnvironmentTypes.qas)) {
      setDescription('Protocolo aberto pela equipe de desenvolvimento CCare - AP');
    }
  }, []);

  const categoriesToHideFields: Array<string> = [
    EnumCategories.RECLAMACAO_TECNICA
  ];

  const visibleDescriptionSimple: boolean = !(categoriesToHideFields.includes(protocolCategory));

  return (
    <Visibility visible={visibleDescriptionSimple}>
      <Column className="mt-5 relative">
        <Text className="mb-2 color-blue-gray" size={12}>
          Descrição
        </Text>
        <TextAreaDescription
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
          value={description}
        />
      </Column>
    </Visibility>
  );
};